"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const react_1 = __importDefault(require("react"));
const Table_styles_1 = require("./Table.styles");
const Table = (props) => react_1.default.createElement(Table_styles_1.StyledTable, Object.assign({}, props));
exports.Table = Table;
Table.Head = Table_styles_1.StyledTableHead;
Table.Body = Table_styles_1.StyledTableBody;
Table.Foot = Table_styles_1.StyledTableFoot;
Table.ColumnGroup = Table_styles_1.StyledTableColumnGroup;
Table.Column = Table_styles_1.StyledTableColumn;
Table.Row = Table_styles_1.StyledTableRow;
Table.Header = Table_styles_1.StyledTableHeader;
Table.DataCell = Table_styles_1.StyledTableDataCell;
//# sourceMappingURL=Table.js.map